'use client';

import { useCallback, useEffect, useRef } from 'react';

function useThrottle<T extends (...args: unknown[]) => void>(callback: T, delay = 300) {
  const wait = useRef(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const throttledFn = useCallback(
    (...args: Parameters<T>) => {
      if (!wait.current) {
        callback(...args);
        wait.current = true;

        timeoutRef.current = setTimeout(() => {
          wait.current = false;
        }, delay);
      }
    },
    [callback, delay]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return throttledFn;
}

export { useThrottle };
